import React, { Component } from "react";

// CSS
import "../../css/forms/dynamic-inputs.css";

class DynamicInputs extends Component {
	render() {
		return (
			<div
				className={`dynamic-input-container` + (!!this.props.hasItems ? ` has-items` : ``)}
			>
				{this.props.children}
				{this.props.disabled ? <React.Fragment></React.Fragment> :
					<div
						className="icon-plus"
						onClick={() => this.props.addInputToCollection(this.props.index)}
					/>
				}
			</div>
		);
	}
}

export default DynamicInputs;



// WEBPACK FOOTER //
// ./src/components/utils/DynamicInputs.js